import React from "react";
import {graphql} from "gatsby";
import {DandadPage} from "../../page_components/DandadPage";

export const query = graphql`{
    editorial(slug: {eq: "d-ad-in-2020"}) {
        ...EditorialFragment
    }
}`

export default ({data: {editorial}}) => <DandadPage editorial={editorial} />